export const TOKEN_KEY = 'token'
export const REFRESH_TOKEN_KEY = 'refreshToken'
export const SESSION_KEY = 'session'
export const ADMIN_ID_KEY = 'ADMIN_ID'
export const PERMISSIONS_KEY = 'permission'
export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL
export const VOUCHER_SERVICE_API_BASE_URL = import.meta.env.VITE_VOUCHER_SERVICE_API_BASE_URL
export const CUSTOM_JSON_HEADERS = {
  'Content-Type': 'application/json',
  accept: 'application/json',
  'Access-Control-Allow-Origin': '*',
}
export const AXIOS_RETRY_COUNT = 3
/** Slow list endpoints fail after this long instead of waiting on the gateway (about a minute). */
export const LIST_REQUEST_TIMEOUT_MS = 20_000
